module.exports = __webpack_public_path__ + "img/103.4.4b0f03d8.png";